/* Gemeinsame Maskottchen-Darstellung (Designregel): Kachel und freigestellte Figur sind getrennte Ebenen; die Figur ragt oben dezent
   über die Kachel hinaus (Kopf/Ohren), nichts wird hart abgeschnitten. Quellen: 1024-px-Freisteller (img/mascots) – scharf bis 512 px CSS @2x.
   Der Parent darf kein overflow-hidden setzen; der Überstand bleibt innerhalb des Wrappers (mobil keine horizontale Scrollbar). */
export const MASCOTS = {
  affe: { src: "/img/mascots/affe.webp", alt: "Maskottchen Affe mit Sonnenbrille und Smartphone" },
  biene: { src: "/img/mascots/biene.webp", alt: "Maskottchen Biene mit Brille" },
  hamster: { src: "/img/mascots/hamster.webp", alt: "Maskottchen Hamster mit Kamera und Fotos" },
  robbie: { src: "/img/mascots/robbie-winkt.webp", alt: "Robbie winkt" },
};

/* Wrapper ist quadratisch; Kachel beginnt bei `overhang` (Anteil der Höhe), die Figur nutzt die volle Höhe → Kopf steht über der Kachel. */
export const MascotTile = ({ className = "", overhang = 14, tileClass = "bg-[#F3F3EE] rounded-[2.5rem]", children, testId }) => (
  <div className={`relative aspect-square ${className}`} data-testid={testId}>
    <div className={`absolute inset-x-0 bottom-0 ${tileClass}`} style={{ top: `${overhang}%` }} aria-hidden="true" />
    {children}
  </div>
);

export const mascotImgClass = "absolute inset-0 z-[1] w-full h-full object-contain object-bottom px-4 select-none pointer-events-none";

export const MascotBadge = ({ mascot = "robbie", className = "", testId }) => {
  const m = MASCOTS[mascot] || mascot;
  return <img src={m.src} alt={m.alt} width="1024" height="1024" loading="lazy" decoding="async" draggable="false" className={`object-contain select-none ${className}`} data-testid={testId} />;
};
